<template>
    <div>
        <ClientMapComponent />
    </div>
</template>

<script>

import ClientMapComponent from "../components/DataComponents/ClientMapComponent.vue";

export default {
    name: "client-map-view",
    components: { ClientMapComponent },
    title: 'ClientMap',
};
</script>
